





























































































































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Temp, User, Token} from '@/models';

import storeTemp from '@/stores/modules/temp';

import InputPhone from '@/components/Input/Phone.vue';
import InputCountry from "@/components/Input/Country.vue";
import InputZipCode from "@/components/Input/ZipCode.vue";

import storeClient from "@/stores/modules/client"
import storeProjet from "@/stores/modules/projet";
import storeTache from "@/stores/modules/tache";
import storeUser from '@/stores/modules/user';
import InputDatePicker from "@/components/Input/DatePicker.vue";
import {Stored} from "vue-stored-prop-decorator";
import axios from "axios";
import storeToken from "@/stores/modules/token";

@Component({
	components: {
		InputPhone,
		InputCountry,
		InputZipCode,
		InputDatePicker,
	}
})
export default class CrudTempEdit extends AbstractEditVue<Temp> {

	@Stored(() => storeUser) me!: User;

	private step: number = 1;
	private storeClient = storeClient;
	private storeProjet = null;
	private storeTache = null;
	private storeUser = storeUser;

	private checkInput = true

	@Stored(() => storeToken)
	private token: Token;

	public constructor() {
		super(
			storeTemp,
			'Temps modifié',
			'Temps créé',
		);
	}

	protected async onSubmit(): Promise<void> {
		super.onSubmit();
		this.step = 1;
	}

	public async mounted(): Promise<void> {
		await storeClient.dispatch('getAll');
		await storeUser.dispatch('getAll');
		await super.mounted();
		this.item.user = this.item.user ? this.item.user : this.me
		await this.refreshInputs();
		this.watchInput()
	}

	public async refreshInputs() {
		await axios.get(`${process.env.VUE_APP_BACK_BASE_URL}/api/projets/list/${this.item.client ? this.item.client.id : '0'}?token=${this.token.id}`, {},
		).then(response => {
			this.storeProjet = response.data;
		});

		if (!this.item.client || this.item.projet && this.item.client.id != this.item.projet.client.id) {
			this.item.projet = null;
		}

		if (!this.item.projet || this.item.tache && this.item.projet.id != this.item.tache.projet.id || this.item.projet && this.item.client.id != this.item.projet.client.id) {
			this.storeTache = null;
			this.item.tache = null;
		} else {
			await axios.get(`${process.env.VUE_APP_BACK_BASE_URL}/api/taches/list/${this.item.projet ? this.item.projet.id : '0'}?token=${this.token.id}`, {},
			).then(response => {
				this.storeTache = response.data;
			});
		}
	}

	public async refresh(): Promise<void> {
		await super.refresh();
		if (this.$route.name === 'temps-edit') {
			this.$route.meta.title = 'Modification  d\'un temps';
		}
	}

	public watchInput() {
		if (this.item.client && this.item.user && this.item.duration && this.item.projet || this.item.description && this.item.duration ) {
			this.checkInput = false
		} else {
			this.checkInput = true
		}
	}

}
